<template>
	<div class="page_container flex_wrap column j_c_between a_i_center">

		<header class="title">
			<h1>接送查询</h1>
			<div class="filtrate_wrap flex_wrap wrap">
				<div class="select_wrap flex_wrap j_c_center a_i_center">
					<select class="select" v-model="dateType" style="color: #000000 !important;background: #FFFFFF !important;">
						<option :value="item.value" v-for="(item, index) in dateSelection" :key="index" style="color: #000000 !important;background: #FFFFFF !important;">{{ item.text }}</option>
					</select>
				</div>
				<div class="date_wrap flex_wrap a_i_center j_c_around">
					<input class="date" type="date" v-model="startDate":disabled="isLimit" style="color: #000000 !important;background: #FFFFFF !important;" />
					<span class="">至</span>
					<input class="date" type="date" v-model="endDate" :disabled="isLimit" style="color: #000000 !important;background: #FFFFFF !important;" />
				</div>
        <div><button @click="getStatData">查 询 统 计</button></div>
        <div><button @click="clearline">清 除 线 路</button></div>


			</div>
		</header>

		<div class="index_content">
			<h3 v-if="statData && statData.length && statData.length > 0">统计列表</h3>
			<div class="table statistics_table" v-if="statData && statData.length && statData.length > 0">
				<ul class="tr bg_tr flex_wrap">
					<li class="th">日期</li>
					<li class="th">S去</li>
					<li class="th">S返</li>
					<li class="th">L去</li>
					<li class="th">L返</li>
				</ul>
				<ul class="tr flex_wrap" v-for="(record, index) in statData" :key="index">
					<li class="td" @click="getReportData(record.day)">{{ record.day }}</li>
          <li class="td" @click="getReportData(record.day)">{{ record.shortGoCount }}</li>
          <li class="td" @click="getReportData(record.day)">{{ record.shortBackCount }}</li>
          <li class="td" @click="getReportData(record.day)">{{ record.longGoCount }}</li>
          <li class="td" @click="getReportData(record.day)">{{ record.longBackCount }}</li>
				</ul>
				<ul class="tr bg_tr flex_wrap">
					<li class="th">合计</li>
					<li class="th">{{ this.totalShortGoCount }}</li>
					<li class="th">{{ this.totalShortBackCount }}</li>
					<li class="th">{{ this.totalLongGoCount }}</li>
					<li class="th">{{ this.totalLongBackCount }}</li>
				</ul>
			</div>

			<h3 v-if="reportData && reportData.length && reportData.length > 0">接送列表</h3>
			<div class="table statistics_table" style="height: 500px;" v-if="reportData && reportData.length && reportData.length > 0">
        <div style="border-radius: 10px;" ref="allMap" id="allMap"></div>
			</div>

      <Modal
          v-model="isdriver"
          title="选择司机"
          @on-ok="confirdir">
          <RadioGroup v-model="driver" vertical @on-change="selcetDriver()">
              <Radio label="孙智明">
                  <Icon type="social-apple"></Icon>
                  <span>孙智明</span>
              </Radio>
              <Radio label="温富强">
                  <Icon type="social-android"></Icon>
                  <span>温富强</span>
              </Radio>
              <Radio label="刘武力">
                  <Icon type="social-windows"></Icon>
                  <span>刘武力</span>
              </Radio>
              <Radio label="余雪松">
                  <Icon type="social-windows"></Icon>
                  <span>余雪松</span>
              </Radio>
              <Radio label="林达志">
                  <Icon type="social-windows"></Icon>
                  <span>林达志</span>
              </Radio>
              <Radio label="王李特">
                  <Icon type="social-windows"></Icon>
                  <span>王李特</span>
              </Radio>
              <Radio label="订单已取消">
                  <Icon type="social-windows"></Icon>
                  <span>订单已取消</span>
              </Radio>
          </RadioGroup>
      </Modal>



		</div>
		<footer class=""></footer>
	</div>
</template>


<script>

  import businessApi from '@/request/businessApi';
  import addressApi from '@/request/addressApi';
  import salesApi from '@/request/salesApi';

  import Header from './child-components/Header';
  import Swiper from './child-components/Swiper';
  import publicBusinessInfo from './child-components/publicBusinessInfo';
  import InputInfo from './child-components/InputInfo';

import baseTool from '@/utils/baseFunction';
import appointApi from '@/request/appointApi';
import { mapState } from 'vuex';
export default {
	name: 'PickupList',
	data() {
		return {
			startDate: '',
			endDate: '',
			dateType: 'set',
      orderstatetype:['待支付','已支付','已完成','申请退款','已退款'],
			dateSelection: [{ text: '预约日期', value: 'set' }, { text: '下单日期', value: 'create' }],
			limitSelection: [{ text: '限制接送', value: '0' }, { text: '限制包车', value: '1' }],
			statData: [],
			reportData: [],
			limitDate: [],
			// fromParams: '',
			orderTypeList: ['随意约', '车票接送', '长途接送', '单接送'],
			limitTypeList: ['接送限制', '包车限制'],
			token: '',
			shortCount: 0,
			longCount: 0,
			totalPrice: 0,
			limitType: 0,
			startTime: '00:00',
			endTime: '23:59',
			isGo: 1,
			driverList: [],
			orderModal: {
				Show: false,
				OrderId: 0,
				DriverName: ''
			},
			limitList: [
        'oDcOv58kUAzt5R41TXh3dMHkpMn0',
        'oDcOv5zC_N25OIUWf8BxUjYStfCo',
        'oDcOv54xoytxmlssNHpOZFae-v98',
        // 'oDcOv57DvUXxlkVYSN3crPY3GyrU',
        // 'oDcOv57N6MNSYQ_mC6aWm22RMmMA',
        // 'oDcOv5-_qOULIa83Eu1mJ1hHmQlc',
        // 'oDcOv5-RHuQ9KpuuFWigz9OJJ59M',
        'oDcOv58FNF3hahDwcRre1zGaNc30',
        // 'oDcOv5_QLaHP4C5GxCjB5QkbGnnI',
        // 'oDcOv56qU_gCqSOzWOsqDa0ngxsk',
        'oDcOv53CF-i3W8SwTwk7gmDCnCQs',
        // 'oDcOv518urXrhW68jr11kRNXD_4Q',
        // 'oDcOv571_57f_828sZRDE9W4i0_Y',
        // 'oDcOv5yGc-Ceh9oaF5b1V6J4uMwA',
        // 'oDcOv57WdhufWlnKGXORwoAXMUoQ',
        // 'oDcOv51E6rLOtckXC9LIzVjYRySw',
        // 'oDcOv57zMLIpqqkaELTg6-3rREQo',
        // 'oDcOv5_7_W2zGAai1u9IiEZr4frQ',
        // 'oDcOv54zMhb84E4nF5QIQI7jJKyQ',
        // 'opz0c5JiBNEIDzZQ_MEqd0FRcO5E',
        'oDcOv5wzSPhI9T1IwG1kMM5KeWKM',
        // 'oDcOv54bj6xRb0Y1Z_ArqSpsNYiU',
        'oDcOv50GwEWF3eU4NGWMeNvP4nFU',
			],
      //进入页面控制
			enableList: [
				// 'oDcOv54-HL9VoWh1_Ukynkw4QvaM',
				'oDcOv58kUAzt5R41TXh3dMHkpMn0',
				'oDcOv5zC_N25OIUWf8BxUjYStfCo',
        'oDcOv58FNF3hahDwcRre1zGaNc30',
        'oDcOv54xoytxmlssNHpOZFae-v98',
				// 'oDcOv57DvUXxlkVYSN3crPY3GyrU',
				// 'oDcOv57N6MNSYQ_mC6aWm22RMmMA',
				// 'oDcOv5-_qOULIa83Eu1mJ1hHmQlc',
				// 'oDcOv5-RHuQ9KpuuFWigz9OJJ59M',
				// 'oDcOv5_QLaHP4C5GxCjB5QkbGnnI',
				// 'oDcOv56qU_gCqSOzWOsqDa0ngxsk',
				'oDcOv53CF-i3W8SwTwk7gmDCnCQs',
				// 'oDcOv518urXrhW68jr11kRNXD_4Q',
				// 'oDcOv571_57f_828sZRDE9W4i0_Y',
				// 'oDcOv5yGc-Ceh9oaF5b1V6J4uMwA',
				// 'oDcOv57WdhufWlnKGXORwoAXMUoQ',
				// 'oDcOv51E6rLOtckXC9LIzVjYRySw',
				// 'oDcOv57zMLIpqqkaELTg6-3rREQo',
    //     'oDcOv5_7_W2zGAai1u9IiEZr4frQ',
    //     'oDcOv54zMhb84E4nF5QIQI7jJKyQ',
    //     'opz0c5JiBNEIDzZQ_MEqd0FRcO5E',
        'oDcOv5wzSPhI9T1IwG1kMM5KeWKM',
    //     'oDcOv54bj6xRb0Y1Z_ArqSpsNYiU',
        'oDcOv50GwEWF3eU4NGWMeNvP4nFU',
			],
			enableNameList: [
				// '黄得源',
				'林达志',
				'钱凯园',
        '何诗雅',
        '招振凤',
				// '罗志一',
				// '郭堃怡',
				// '霍桂峰',
				// '廖曼莉',
				// '吴理强',
				// '梁浩民',
				'王李特',
				// '罗爱玲',
				// '雷沛婷',
				// '吴瑞彬',
				// '李丹艳',
				// '朱姐',
				// '温富强',
    //     '周静',
    //     '王弘臣',
    //     '周静',
        '梁灏锋',
    //     '梁灏锋',
        '谭功明',
			],
			isLimit: true,
      showinfo:false,
      DriverList:[],
      customInfo:[],
      busPeople:'',
      busPhone:'',
      busTime:'',
      hisDriverTable:[],
      applyRefund:['oDcOv58FNF3hahDwcRre1zGaNc30'],
      refundShow:false,
      map: null,
      path:[],
      haspath:[],
      linecolcor:["#FF0000","#FF00FF","#00FFFF","#0000FF","#FFFF00","#FF8000","#800000","#FF80C0","#400040","#400000","#000000"],
      labellist : [],
      positions:[],
      positionspoint:[],
      driver:'',
      isdriver:false,
      selectdate:'',
      orderidlist:[],
		};
	},
	activated() {

    var element = document.createElement("script");
    element.src = "https://webapi.amap.com/maps?v=1.4.15&key=334c48072cfa134cb568db91fa7a2044";
    document.body.appendChild(element);

		this.startDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.endDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
		this.getDriverList();
		this.tmpTimer = setInterval(() => {
			if (this.OpenId && this.OpenId.length > 0) {

        if (this.applyRefund.indexOf(this.OpenId) != -1) {
          this.refundShow = true;
        }


				clearInterval(this.tmpTimer);
				if (this.enableList.indexOf(this.OpenId) == -1) {
					// 直接滚
					alert('走错路了抱歉！');
					this.$router.push({
						name: 'MainIndexPage'
					});
				} else {
					if (this.limitList.indexOf(this.OpenId) != -1) {
						this.isLimit = false;
					}
				}
			}
		}, 500);
	},
	methods: {

		getOrderStationType(params) {
			if (params != '' && params.length == 11) {
				return '[现场]';
			} else if (params == '') {
				return '[公众号]';
			} else if (params.length < 11 && params.length > 0) {
				return '[车上]';
			}
		},
		getDriverList() {
			appointApi.getDriverList().then(sucRes => {
				if (sucRes.success) {
					this.driverList = sucRes.data;
				}
			});
		},
		getStatData() {
			this.statData = [];
			appointApi.getAppointStatReportList(this.$store.state.user.OpenId, this.startDate, this.endDate, this.dateType).then(sucRes => {
				if (sucRes.success) {
					this.statData = sucRes.data;
				}
			});
		},

		getReportData(dateTime) {
      var that = this;
      that.selectdate = dateTime;
			this.reportData = [];
			this.limitDate = [];
      that.positions = [];
      that.positionspoint=[];
			this.shortCount = 0;
			this.longCount = 0;
			this.totalPrice = 0;
			appointApi.GetOrderLatitudeList(dateTime ? dateTime : this.startDate, dateTime ? dateTime : this.endDate, '', dateTime ? 'set' : this.dateType, this.token)
				.then(sucRes => {
					if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
						this.reportData = sucRes.data;
            for (let i = 0; i < this.reportData.length; i++) {
              that.positions.push(new AMap.LngLat(sucRes.data[i].bookingStartPointLo,sucRes.data[i].bookingStartPointLa));
              that.positionspoint.push(sucRes.data[i].num);
						}

            this.$nextTick(() => {
              that.path = [];
              that.labellist = [];
              that.orderidlist = [];

              that.haspath=[];
              that.map = new AMap.Map('allMap', {
                resizeEnable: true, //是否监控地图容器尺寸变化
                // zoom: 12, //初始化地图层级
                zooms:[3,19],
                center: [113.34951628659056,22.532840848907682] //初始化地图中心点//候机楼
              });

              appointApi.GetAppOrderDispatchList(dateTime ? dateTime : this.startDate, dateTime ? dateTime : this.endDate, '', dateTime ? 'set' : this.dateType, this.token).then(sucRes => {
              if(sucRes.success){
                for(var i=0;i<sucRes.totalCount;i++){
                  console.log('11111111111111',sucRes.data[i].infolsit)
                  var haspathpoint=[];
                  for(var j=0;j<sucRes.data[i].infolsit.length;j++){
                    haspathpoint.push([sucRes.data[i].infolsit[j].bookingStartPointLo,sucRes.data[i].infolsit[j].bookingStartPointLa]);
                  }
                  that.haspath.push({haspathpointlist:[haspathpoint]})
                }

                console.log('aaaaaaaaaaaaaa',that.positions)
                console.log('ssssssssssssssss',that.positionspoint)
                console.log('ddddddddddddddd',that.haspath)

                for(var k=0;k<that.haspath.length;k++){

                  that.map.plugin("AMap.DragRoute", function() {
                      var route = new AMap.DragRoute(that.map,that.haspath[k].haspathpointlist[0], AMap.DrivingPolicy.LEAST_FEE,
                      {polyOptions:{strokeColor:that.linecolcor[k]},showTraffic:false});
                      route.search(); //查询导航路径并开启拖拽导航
                  });
                }
              }
              else{
                that.$Message.error(sucRes.message);
              }
              })




              that.map.on('complete', function(){
                for (var i = 0; i < that.positions.length; i++) {
                  var marker = new AMap.Marker({
                    map: that.map,
                    position: that.positions[i]
                  });

                  // 设置label标签
                  marker.setLabel({
                    offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                    content: that.positionspoint[i], //设置文本标注内容
                    direction: 'top' ,//设置文本标注方位
                  })

                  //


                  marker.on('click', (e)=>{
                    console.log(e)
                    console.log(that.reportData)

                    // console.log('aaaaaaaaa',getpoint)
                    // console.log('aaaaaaaaa',getpoint.lng,getpoint.lat)

                    // that.$Message.success('已点击地点'+e.target.Ce.label.content);


                    for(var a=0;a<that.reportData.length;a++){
                      if(that.reportData[a].num == e.target.Ce.label.content){
                        that.labellist.push(that.reportData[a].ordernum)

                        that.path.push(new AMap.LngLat(that.reportData[a].bookingStartPointLo,that.reportData[a].bookingStartPointLa));
                        if(e.target.Ce.label.content == '候机楼' || e.target.Ce.label.content == '中山港'){
                        }
                        else{
                          that.orderidlist.push(that.reportData[a].AppointOrder.ID)
                          if(that.reportData[a].Order.OrderList_InfoList != null){
                            var bustime = that.reportData[a].Order.OrderList_InfoList[0].OrderList_InfoFrequencyList[0].SetTime.replace("T", " ");
                            that.$Modal.success({
                                title: '已点击地点信息'+','+e.target.Ce.label.content,
                                content: '接送地址：'+that.reportData[a].AppointOrder.StartDistrict+that.reportData[a].AppointOrder.bookingStartAddr +','+'姓名：'+that.reportData[a].AppointOrder.Contact+','+'电话号码：'+that.reportData[a].AppointOrder.riderPhone+','+'大巴时间：'+bustime,
                            });
                          }
                          else{
                            that.$Modal.success({
                                title: '已点击地点信息'+','+e.target.Ce.label.content,
                                content: '接送地址：'+that.reportData[a].AppointOrder.StartDistrict+that.reportData[a].AppointOrder.bookingStartAddr +','+'姓名：'+that.reportData[a].AppointOrder.Contact+','+'电话号码：'+that.reportData[a].AppointOrder.riderPhone+','+'大巴时间：无',
                            });
                          }

                        }

                        console.log('that.labellist',that.labellist)
                      }
                    }

                    // that.path.push(new AMap.LngLat(e.lnglat.lng,e.lnglat.lat));
                    // that.path.push(new AMap.LngLat(getpoint.lng,getpoint.lat));

                    // var subgetLng = String(e.lnglat.lng).substring(0,7);
                    // console.log(subgetLng)

                    // var subgetLat = String(e.lnglat.lat).substring(0,6);
                    // console.log(subgetLat)

                    if(e.target.Ce.label.content == '候机楼' || e.target.Ce.label.content == '中山港'){
                      that.map.plugin("AMap.DragRoute", function() {
                        console.log(that.path)
                          var route = new AMap.DragRoute(that.map, that.path, AMap.DrivingPolicy.LEAST_FEE,
                          {polyOptions:{strokeColor:"#006600"},showTraffic:false});
                          route.search(); //查询导航路径并开启拖拽导航

                          console.log(that.labellist)

                          that.$Modal.confirm({
                              title: "是否确认",
                              content: '确认行经路线？需要指派司机？',
                              onOk: () => {
                                that.isdriver = true;
                                  // that.$Message.info('Clicked ok');
                              },
                              onCancel: () => {
                                  // that.$Message.info('Clicked cancel');
                              }
                          });

                      });

                    }


                    //   that.map.plugin("AMap.DragRoute", function() {
                    //     console.log(that.path)
                    //       var route = new AMap.DragRoute(that.map, that.path, AMap.DrivingPolicy.LEAST_FEE,
                    //       {polyOptions:{strokeColor:"#006600"},showTraffic:false});
                    //       route.search(); //查询导航路径并开启拖拽导航

                    //       console.log(that.labellist)
                    // if(e.target.Ce.label.content == '候机楼' || e.target.Ce.label.content == '中山港'){
                    //       that.$Modal.confirm({
                    //           title: "是否确认",
                    //           content: '确认行经路线？需要指派司机？',
                    //           onOk: () => {
                    //             that.isdriver = true;
                    //               // that.$Message.info('Clicked ok');
                    //           },
                    //           onCancel: () => {
                    //               // that.$Message.info('Clicked cancel');
                    //           }
                    //       });
                    //       }

                    //   });




                  })

                  that.map.add(marker);
                }
                marker.on('click', (e)=>{
                  var getpoint = marker.getPosition();
                  console.log('aaaaaaaaa',getpoint)
                  console.log('aaaaaaaaa',getpoint.lng,getpoint.lat)
                })

              });
            })
					}
          else{
            that.$Message.error(sucRes.message);
          }
				});
		},
    clearline(){
      console.log('qweqeasdasd',this.selectdate)
      this.getReportData(this.selectdate)
    },
    selcetDriver(){
      console.log('qweqeasdasd',this.driver)
      console.log('qweqeasdasd',this.labellist)
      console.log('xxxxxxxxxxx1',this.orderidlist)
    },
    confirdir(){
      var that=this;
      console.log('zzzzzzzzzz',this.driver)
      console.log('xxxxxxxxxxx',this.labellist)

      var listStr = that.labellist.toString();
      console.log('xxxxxxxxxxx',listStr)
      console.log('xxxxxxxxxxx1',that.orderidlist)
      appointApi.CreateOrderDispatch(listStr,that.driver,that.selectdate).then(sucRes => {
        console.log(sucRes)
        if (sucRes.success) {
          for(var i=0;i<that.orderidlist.length;i++){
            appointApi.bindDriverToAppointOrder(that.$store.state.user.OpenId, that.driver, that.orderidlist[i], 0, '').then(sucRes => {
              if(sucRes.success){
                that.getReportData(that.selectdate);
              }
              else{
                that.$Message.error(sucRes.message);
              }
            })
          }
        }
        else{
          that.$Message.error(sucRes.message);
        }

      })


    },
		getLimitDateList() {
			this.reportData = [];
			this.limitDate = [];
			appointApi.getAppointLimitDateList(this.limitType).then(sucRes => {
				if (sucRes.success && sucRes.data && sucRes.data.length > 0) {
					sucRes.data.forEach(val => {
						val.LimitStartDate = baseTool.dateFormat(new Date(val.LimitStartDate), 'yyyy-MM-dd HH:mm');
						val.LimitEndDate = baseTool.dateFormat(new Date(val.LimitEndDate), 'yyyy-MM-dd HH:mm');
					});
					this.limitDate = sucRes.data;
				}
			});
		},
		invalidRecord(id) {
			appointApi.invalidPickupLimit(this.$store.state.user.OpenId, id).then(sucRes => {
				if (sucRes.success) {
					alert(sucRes.message);
					this.getLimitDateList();
				} else {
					alert(sucRes.message);
				}
			});
		},
		addLimit() {
			appointApi.addLimit(this.$store.state.user.OpenId, this.startDate, this.endDate, this.startTime, this.endTime, this.limitType, this.isGo).then(sucRes => {
				if (sucRes.success) {
					alert(sucRes.message);
					this.getLimitDateList();
				} else {
					alert(sucRes.message);
				}
			});
		},
		bindDriverToAppointOrder(item) {
			let that = this;
			this.DriverList = [];
      this.hisDriverTable = [];
			for (let i = 0; i < this.driverList.length; i++) {
				let driverTmp = {
					label: this.driverList[i].DriverName,
					value: this.driverList[i].DriverName
				};
				this.DriverList.push(driverTmp);
			}
      console.log('item',item)
      if(item.FromOrderNum != ''){
        appointApi.GetUserHistoryOrderByApp(item.UserID,0,item.FromOrderNum).then(hisBisRes => {
          console.log('车票hisBisRes',hisBisRes)
          this.busPeople = hisBisRes.data.OrderList_InfoList[0].RealName;
          this.busPhone = hisBisRes.data.OrderList_InfoList[0].Mobile;
          this.busTime = hisBisRes.data.OrderList_InfoList[0].OrderList_InfoFrequencyList[0].SetTime.replace("T", "  ");
        })
      }
      else{
        this.busPeople = '无';
        this.busPhone = '无';
        this.busTime = '无';
      }
      appointApi.GetUserHistoryOrderByApp(item.UserID,1,'').then(hisCarRes => {
        console.log('约车hisCarRes',hisCarRes)
        if(hisCarRes.totalCount > 1){
          var nameArr = [];
          for(var i=1;i<=hisCarRes.totalCount-1;i++){
            hisCarRes.data[i].bookingDate = hisCarRes.data[i].bookingDate.replace("T", "  ");
            nameArr.push(hisCarRes.data[i]);
            // this.hisDriverTable = this.hisDriverTable.push(hisCarRes.data[i]);
            // nameArr.push(hisCarRes.data[i].DriverName);
            // this.carDriver += hisCarRes.data[i].DriverName + ';'
          }
          this.hisDriverTable = nameArr;
          console.log('hisDriverTable',this.hisDriverTable)
          // this.carDriver = nameArr.join(";");;
          // this.carTime = hisCarRes.data[1].bookingDate.replace("T", "  ");
        }
        else if(hisCarRes.totalCount == 1){
          this.hisDriverTable = [];
          // this.carTime = '无';
          // this.carDriver = '无';
        }
      })

      item.CreateDate = item.CreateDate.replace("T", "  ")
      this.customInfo = item;
      this.showinfo = true;

		},
    Isok(){
      var that = this;
      this.showinfo = false;
      this.$weui.picker(this.DriverList, {
      	onConfirm: result => {
      		let driverName = result[0].value;
      		let orderId = this.customInfo.ID;
      		that.orderModal.Show = true;
      		that.orderModal.DriverName = driverName;
      		that.orderModal.OrderId = orderId;
      	}
      });
    },
		bindOrderToDriver(driverName, orderId, isBind) {
			appointApi.bindDriverToAppointOrder(this.$store.state.user.OpenId, driverName, orderId, isBind, '').then(sucRes => {
				if (sucRes.success) {
					for (let i = 0; i < this.reportData.length; i++) {
						if (this.reportData[i].ID == this.customInfo.ID) {
							this.reportData[i] = sucRes.data;
						}
					}
          alert(sucRes.message);
				} else {
					alert(sucRes.message);
				}
			});
		},
	},
	computed: mapState({
		OpenId: state => state.user.OpenId,
		totalShortGoCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.shortGoCount;
				});
			}
			return total;
		},
		totalShortBackCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.shortBackCount;
				});
			}
			return total;
		},
		totalLongGoCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.longGoCount;
				});
			}
			return total;
		},
		totalLongBackCount() {
			var total = 0;
			if (this.statData.length > 0) {
				this.statData.forEach(val => {
					total += val.longBackCount;
				});
			}
			return total;
		}
	})
};
</script>

<style scoped="scoped" type="text/css">
.title {
	width: 100%;
	background-color: #005242;
	text-align: center;
}
.title h1 {
	width: 100%;
	line-height: 10vh;
	color: #fff;
	font-size: 0.5rem;
}
.filtrate_wrap {
	width: 100%;
	border-top: 5px solid #f8f8f8;
	padding: 0.2rem 0;
}
.filtrate_wrap > div {
	margin: 0.2rem 0 0.2rem 0.3rem;
}
.select_wrap,
.date_wrap,
.btn_wrap {
	align-self: stretch;
	height: 4vh;
	position: relative;
}
.select,
.date {
	box-sizing: border-box;
	align-self: stretch;
	background-color: #555;
	font-size: 0.35rem;
	outline: none;
	color: #fff;
	border: 1px solid #888;
}

.select {
	width: 100%;
}

.date_wrap > span {
	margin: 0 0.2rem;
	color: #fff;
}
.demand_btn {
	background-color: #f8f8f8;
	color: #333;
}
.demand_btn:active {
	background-color: #ddd;
	color: #555;
}

.index_content {
	width: 100%;
	flex: 1;
	padding: 0.2rem;
	overflow-y: scroll;
}
.table {
}
.bg_tr {
	background-color: #888;
}
.tr {
	color: #fff;
}
.td {
	color: #888;
}
.statistics_table .tr:last-child .td {
	color: #fff;
}
.bg_huizong {
	background-color: #2fdab9;
}

.tong_ji {
	border-bottom: 1px solid #888;
}
.index_content h3:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.index_content h3 {
	text-align: center;
	color: #fff;
	line-height: 4vh;
	background-color: #06967a;
}

body,
ol,
ul,
h1,
h2,
h3,
h4,
h5,
h6,
p,
th,
td,
dl,
dd,
form,
fieldset,
legend,
input,
textarea,
select {
	margin: 0;
	padding: 0;
}
body {
	font: 12px/24px '微软雅黑', 'Arial Narrow', HELVETICA;
	-webkit-text-size-adjust: 100%;
}
a {
	color: #2d374b;
	text-decoration: none;
}
a:hover {
	color: #cd0200;
	text-decoration: underline;
}
em {
	font-style: normal;
}
li {
	list-style: none;
}
button,
input {
	outline: none;
}
img {
	border: 0;
	vertical-align: middle;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
div {
	box-sizing: border-box;
}
p {
	word-wrap: break-word;
}

html {
	height: 100%;
}

body {
	margin: 0 auto;
	width: 10rem;
	height: 100%;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
}
.page_container {
	width: 100%;
	height: 100%;
	margin: 0 auto;
}
.flex_wrap {
	display: flex;
}
.row {
	flex-direction: row;
}
.column {
	flex-direction: column;
}
.wrap {
	flex-wrap: wrap;
}
.j_c_center {
	justify-content: center;
}
.j_c_start {
	justify-content: flex-start;
}
.j_c_end {
	justify-content: flex-end;
}
.j_c_around {
	justify-content: space-around;
}
.j_c_between {
	justify-content: space-between;
}
.a_i_center {
	align-items: center;
}
.a_i_start {
	align-items: flex-start;
}
.a_i_end {
	align-items: flex-end;
}

.btn {
	outline: none;
	border: 1px solid #888;
	border-radius: 4px;
}

.table {
	width: 100%;
	border: 1px solid #aaa;
}
.table:nth-child(n + 2) {
	margin-top: 0.2rem;
}
.tr {
	justify-content: space-around;
	align-items: center;
	flex: 1;
}
.th:nth-last-child(n + 2),
.td:nth-last-child(n + 2) {
	border-right: 1px solid #ddd;
}
.tr:nth-last-child(n + 2) {
	border-bottom: 1px solid #ddd;
}
.th,
.td {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	flex-wrap: wrap;
	word-break: break-all;
	text-align: center;
}
.td {
	padding: 0.1rem;
}

@font-face {
	font-family: 'iconfont';
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot');
	src: url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.woff') format('woff'),
		url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.ttf') format('truetype'), url('//at.alicdn.com/t/font_769799_12u3p6mm2mji.svg#iconfont') format('svg');
}
.iconfont {
	font-family: 'iconfont' !important;
	/*font-size:40rpx;*/
	margin: 0 5px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.iconreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(-1);
}
.noticonreversal {
	transition: all 0.3s;
	display: inline-block;
	transform: scaleY(1);
}
.showinfo p{
  margin-bottom: 5px;
}

#panel {
	position: fixed;
	background-color: white;
	max-height: 90%;
	overflow-y: auto;
	top: 10px;
	right: 10px;
	width: 280px;
}
#panel .amap-call {
	background-color: #009cf9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow: hidden;
}
#allMap {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PickupList.vue